import VideoCard from '@/components/feature/VideoCard';
import { videos } from '@/mocks/data';

export default function LatestVideos() {
  const latest = [...videos].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  return (
    <section id="latest-videos" className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            <i className="ri-time-line text-secondary-500 mr-2"></i>
            最新视频
          </h2>
          <p className="text-sm text-foreground-500 mt-1">实时更新，不错过任何一个爆料</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {latest.map((video) => (
          <VideoCard key={video.id} {...video} />
        ))}
      </div>
    </section>
  );
}